import { useState, useEffect } from 'react';
import { ChangeAlertCallbackType } from "../../../Root";

export const useFeatureUpdate = ( open: boolean, listCustomers, changeAlert: ChangeAlertCallbackType) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [list, setList] = useState([])
    const [form, setForm ] = useState({
		feature_uuid: "",
		customers: []
	})

    const handleDelete = (uuid) => {
		let f = form 
        let cleanList = list.filter((item) => {
          return item.customer.uuid !== uuid
        })
        f['customers'].splice(f['customers'].indexOf(uuid), 1)

        setList(JSON.parse(JSON.stringify(cleanList)))
        setForm(JSON.parse(JSON.stringify(f)))
        validateForm(JSON.parse(JSON.stringify(f)));
    };

    const onSelectFeature = (event) => {
		let f = form 
		let value = event.target.value as string;
        f['feature_uuid'] = value
		    setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
	};

    const validateForm = (f) => {
        if (f["feature_uuid"] && f["customers"].length > 0 ) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

    useEffect(() => {
		if(!open){
            setList(JSON.parse(JSON.stringify([])))
            setForm({
                feature_uuid: "",
                customers: []
            })
		} else {
            setList(JSON.parse(JSON.stringify(listCustomers)))
            setForm({
                feature_uuid: "",
                customers: listCustomers.map((item) => {
                    return item.customer.uuid
                })
            })
        }

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return { form, list, isValidForm, onSelectFeature, onDelete: handleDelete };

};
